var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 3.5,
    stroke: "#DADADA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9108 9.32031C24.7408 9.32031 25.2109 10.2707 24.7009 10.9307C22.6873 13.5124 18.9855 18.2895 18.9616 18.3203V24.3203C18.9616 24.8702 18.5115 25.3201 17.9616 25.3203H15.9616C15.4116 25.3203 14.9616 24.8703 14.9616 24.3203V18.3203C14.9616 18.3203 11.2317 13.5208 9.2116 10.9307C8.7016 10.2707 9.17164 9.32031 10.0016 9.32031H23.9108ZM11.9616 11.3203L16.9509 17.6201L21.9616 11.3203H11.9616Z",
    fill: "#587E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.e45b6b5aeb8553f7dd6cd0d32cd3deb1.svg";
export { ForwardRef as ReactComponent };